import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Corevalues() {

  // useEffect(()=>{
  //   document.title = 'Elixir | About Us';
  // }, []);

  return (
    <>
    <section className="innerPages">
      <Container>
        <div className="">
          <Row data-aos="fade-up" data-aos-duration="3000">
            <Col lg={3}>
              <div className="innerPages-box1">
                <h1>Elixir & AR <span>Our Jobs</span></h1>
                <h4>Join Elixir Advertising: Innovate, Grow, Succeed</h4>
              </div>
            </Col>
            <Col lg={9}>
            <div className="projectPages-box5">               
              <div className="jobBox">
                <h4>Core Values of Elixir & AR Graphics</h4>
                <p>At <strong>Elixir & AR Graphics</strong>, our Core Values are the guiding principles that define who we are, how we work, and what we stand for. They shape our culture, influence our decisions, and form the foundation of our commitment to excellence.</p>
                <h6>1. Integrity & Ethics</h6>
                <p>We conduct our business with unwavering integrity and uphold the highest ethical standards in every aspect of our operations. Honesty, transparency, and accountability are the cornerstones of our relationships—with clients, partners, and each other.</p>
                <h6>2. Quality Excellence</h6>
                <p>We are dedicated to delivering products and services of the highest quality. Our commitment to excellence ensures that we exceed customer expectations through attention to detail, innovation, and continuous improvement.</p>
                <h6>3. Environmental & Social Responsibility</h6>
                <p>We actively pursue sustainability by aligning our operations with environmental regulations and responsible practices. We believe in contributing positively to society and the planet through ethical sourcing, waste reduction, and socially conscious initiatives.</p>
                <h6>4. Health & Safety</h6>
                <p>We prioritize the health, safety, and well-being of our employees, clients, and communities. By maintaining a safe and supportive work environment, we empower our team to thrive and perform at their best.</p>
                <h6>5. Teamwork & Respect</h6>
                <p>We foster a culture of collaboration, mutual respect, and inclusivity. We value diverse perspectives and believe that our collective strength lies in working together to achieve shared goals.</p>
                <h6>6. Customer-Centric Approach</h6>
                <p>Our clients are at the heart of everything we do. We listen, understand, and adapt to their needs—offering tailored solutions and long-lasting partnerships built on trust.</p>
                <h6>7. Innovation & Growth</h6>
                <p>We embrace creativity and forward-thinking in all our endeavors. Through constant innovation and professional development, we stay ahead of industry trends and deliver impactful solutions.</p>
              </div>
            </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
    </>
  );
}

export default Corevalues;
